import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
import store from "@/store";
import { computed, ref, watch, onMounted, onBeforeUnmount } from "vue";
import { fmtK } from "@/types/utils";
import { calculateCurrentPopulation, calculateFarmCapacity } from "@/utils/population";


export default /*#__PURE__*/_defineComponent({
  __name: 'VillageNavMobile',
  setup(__props) {

const fmtFull = new Intl.NumberFormat('en');

// computed
const activeVillage = computed(() => {
  return store.state.village.village;
});
const tribeNav = computed(() => {
  if (store.state.user.client?.userData?.tribe) {
    return `/tribes/${store.state.user.client.userData.tribe}`;
  }
  return "/tribes";
});
const resources = computed(() => {
  const resource = activeVillage.value?.resources;
  const toNum = (v) => {
    if (typeof v === 'number') return v;
    if (typeof v?.toNumber === 'function') return v.toNumber();
    return Number(v) || 0;
  };
  return {
    food: Math.max(0, toNum(resource?.food)),
    mana: Math.max(0, toNum(resource?.mana)),
    gold: Math.max(0, toNum(resource?.gold)),
  };
});

const currentPopulation = computed(() => {
  return calculateCurrentPopulation(activeVillage.value);
});

const farmCapacity = computed(() => {
  return calculateFarmCapacity(activeVillage.value);
});

const availablePopulation = computed(() => {
  return Math.max(0, farmCapacity.value - currentPopulation.value);
});

// data
const buildingList = ["hq", "barracks", "market"];
const navOpen = ref(false);
const incomingCount = ref(0);
let incomingPoll: ReturnType<typeof setInterval> | null = null;

// methods
function closeNav() {
  navOpen.value = false;
}

function fetchIncomingCount() {
  const client = store.state.user.client;
  const village = store.state.user.active_village;
  if (!client || !village) return;

  client.getActiveAttacks(village).then((attacks: any[]) => {
    const activeKey = village.toString();
    incomingCount.value = attacks.filter(
      (a: any) => !a.account.arrived && a.account.dstVillage?.toString() === activeKey
    ).length;
  }).catch(() => {});
}

// lifecycle
watch(() => store.state.user.active_village, () => fetchIncomingCount());

onMounted(() => {
  setTimeout(() => {
    fetchIncomingCount();
  }, 2000);
  incomingPoll = setInterval(fetchIncomingCount, 60_000);
});

onBeforeUnmount(() => {
  if (incomingPoll) clearInterval(incomingPoll);
});

router.afterEach(() => {
  closeNav();
});

return { __sfc: true,fmtFull, activeVillage, tribeNav, resources, currentPopulation, farmCapacity, availablePopulation, buildingList, navOpen, incomingCount, incomingPoll, closeNav, fetchIncomingCount, fmtK }
}

})